import { ChevronDownIcon } from '@chakra-ui/icons';
import { Button, useDisclosure, Grid, Text } from '@chakra-ui/react';
import React, { FC } from 'react';

import { useRouterIntentState } from '@app/state/routerIntentStore';
import { SelectNetworkModal } from '@app/screens/router-intent/components/SelectNetwork/SelectNetworkModal';
import { NetworkIcon } from '@app/components/NetworkIcon';

export const SelectNetwork: FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { sourceNetwork } = useRouterIntentState();

  return (
    <>
      <Button
        onClick={onOpen}
        minWidth={['110px', '160px']}
        width="fit-content"
        h="100%"
        bg="transparent"
        _hover={{
          background: 'transparent'
        }}
        px={0}
        py="4px"
        borderRadius={4}
        sx={{ cursor: 'pointer' }}
      >
        <Grid
          gridTemplateColumns="24px 1fr 24px"
          gridColumnGap="6px"
          gridRowGap={0}
          w="100%"
          alignItems="center"
        >
          <NetworkIcon
            name={sourceNetwork?.name}
            iconUrl={sourceNetwork?.icon?.url.replace(
              'ipfs://',
              'https://ipfs.io/ipfs/'
            )}
          />
          <Text
            fontSize="16px"
            fontWeight="500"
            lineHeight="20px"
            color="neutral.100"
            textAlign="left"
            overflow="hidden"
            textOverflow="ellipsis"
          >
            {sourceNetwork ? sourceNetwork.name : 'Select network'}
          </Text>
          <ChevronDownIcon />
        </Grid>
      </Button>
      <SelectNetworkModal onClose={onClose} isOpen={isOpen} />
    </>
  );
};
